import { render } from "./canDragCom.vue?vue&type=template&id=765394f6"
import script from "./canDragCom.vue?vue&type=script&lang=js"
export * from "./canDragCom.vue?vue&type=script&lang=js"

import "./canDragCom.vue?vue&type=style&index=0&id=765394f6&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__